<div class="flex flex-col h-full">

    <!-- En-tête du tableau -->
    <div class="flex items-center border border-gray-300 rounded-t-md bg-gray-50 px-4 py-3">
        <span class="flex-1 text-center font-semibold text-base">{{ 'vues.ipad.healthy.headerTitle' | translate }}</span>
        <span class="w-10 flex justify-center">
            @if (allAnswered()) {
            <i class="fas fa-check text-green-500 text-lg"></i>
            }
        </span>
    </div>

    <!-- Liste des questions (accordéon) -->
    <div class="border-x border-b border-gray-300 rounded-b-md divide-y divide-gray-200 overflow-y-auto max-h-[500px]">
        @for (item of items; track item.id) {
        <div>
            <!-- Ligne titre (cliquable) -->
            <div class="flex items-center cursor-pointer px-4 py-3 hover:bg-gray-50"
                (click)="toggleExpand(item.id)">
                <span class="mr-2">
                    @if (isExpanded(item.id)) {
                    <i class="fas fa-chevron-down text-sm text-red-400"></i>
                    } @else {
                    <i class="fas fa-chevron-right text-sm text-red-400"></i>
                    }
                </span>
                <span class="flex-1 text-red-400 font-medium" [innerHTML]="getTitle(item)"></span>
            </div>

            <!-- Contenu HTML + Oui/Non (expandé) -->
            @if (isExpanded(item.id)) {
            <div class="px-6 py-4 bg-white border-t border-gray-100">
                <!-- Contenu HTML de la question -->
                <div class="flex items-start justify-between">
                    <div class="flex-1" [innerHTML]="getContent(item) | safeHtml"></div>
                    <!-- Radio Oui / Non -->
                    <div class="flex flex-col items-end ml-4 space-y-2 min-w-[80px]">
                        <label class="flex items-center cursor-pointer space-x-2">
                            <span class="text-sm text-gray-700">{{ 'buttons.yes' | translate }}</span>
                            <input type="radio"
                                [name]="'health_q_' + item.id"
                                [checked]="getAnswer(item.id) === true"
                                (change)="setAnswer(item.id, true)"
                                class="w-5 h-5 text-green-500 border-gray-300 focus:ring-green-400 cursor-pointer" />
                        </label>
                        <label class="flex items-center cursor-pointer space-x-2">
                            <span class="text-sm text-gray-700">{{ 'buttons.no' | translate }}</span>
                            <input type="radio"
                                [name]="'health_q_' + item.id"
                                [checked]="getAnswer(item.id) === false"
                                (change)="setAnswer(item.id, false)"
                                class="w-5 h-5 text-red-500 border-gray-300 focus:ring-red-400 cursor-pointer" />
                        </label>
                    </div>
                </div>
            </div>
            }
        </div>
        }
    </div>

    <!-- Case d'acceptation globale -->
    <div class="flex items-start space-x-3 mt-6 px-2">
        <label class="flex items-start cursor-pointer"
            [class.opacity-40]="!allAnswered()"
            [class.cursor-not-allowed]="!allAnswered()">
            <input
                type="checkbox"
                [disabled]="!allAnswered()"
                class="w-5 h-5 mt-0.5 rounded border-gray-400 text-blue-600 focus:ring-blue-500"
                [class.cursor-pointer]="allAnswered()"
                [class.cursor-not-allowed]="!allAnswered()"
                [checked]="allAccepted()"
                (change)="onAllAcceptedChange($any($event.target).checked)" />
            <span class="text-gray-700 text-sm leading-snug ml-2">{{ 'vues.ipad.healthy.acceptanceText' | translate }}</span>
        </label>
    </div>

    <!-- Signature (visible uniquement quand toutes les questions sont répondues ET checkbox cochée) -->
    @if (showSignature && allAccepted()) {
    <div class="mt-4">
        <app-signature-pad
            [height]="200"
            [placeholder]="'vues.ipad.signaturePlaceHolder' | translate"
            (signatureChange)="onSignatureChange($event)">
        </app-signature-pad>
    </div>
    }

</div>